import { render, staticRenderFns } from "./NewList.vue?vue&type=template&id=cf943552&scoped=true"
import script from "./NewList.vue?vue&type=script&lang=js"
export * from "./NewList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf943552",
  null
  
)

export default component.exports